import { PermissionModel, RecordPermissionModel } from '../models';

export const permissionsListToRecord = (items: PermissionModel[]): RecordPermissionModel =>
  items.reduce((acc, cur) => {
    const { id, code, name, dependenciesApiPermissions = [], children = [] } = cur;

    return {
      ...acc,
      [code]: {
        id,
        code,
        name: name ?? code,
        dependenciesApiPermissions,
        ...(children.length > 0 ? { children: permissionsListToRecord(children) } : {}),
      },
    };
  }, {} as RecordPermissionModel);
